'use client'

import React, { useState } from 'react'
import {
  Box,
  Button,
  Card,
  Flex,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { IRedux } from '@/app/[locale]/_store/types'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'

const QRModal = dynamic(() => import('../../profile/_components/QRModal'), {
  ssr: false,
})
const QRCodeCanvas = dynamic(
  () => import('qrcode.react').then((mod) => mod.QRCodeCanvas),
  { ssr: false }
)

function CashbackQR() {
  const { user } = useSelector((state: IRedux) => state.auth)
  const settings = useSelector((state: IRedux) => state.settings)
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )
  const t = useTranslations()

  const [isQR, setQR] = useState(false)

  if (
    isDesktop ||
    !user?.phone ||
    !settings?.data?.data?.cashback_display_places?.includes('main')
  ) {
    return null
  }

  return (
    <Card.Root
      rounded={16}
      m={4}
      variant='subtle'
      bg='primary'
      color='text'
      cursor={'pointer'}
      transition='box-shadow 0.2s ease-in-out'
      _hover={{
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      }}
      p={4}
      onClick={() => setQR(true)}
    >
      <Card.Body p={0}>
        <Flex justifyContent='space-between' gap={4}>
          <Flex direction='column' justifyContent='space-between'>
            <Text fontWeight={700} fontSize='sm' color='primary.text'>
              {t('show_qr_to_cashier')}
            </Text>
            <Button
              rounded={12}
              variant='subtle'
              height={{ lg: 12 }}
              bg='background.card'
              color='text'
            >
              {t('open')}
            </Button>
          </Flex>
          <Box bg='#fff' p={3} rounded={16}>
            <QRCodeCanvas
              value={user?.phone?.replace('+', '')}
              size={80}
              bgColor='#ffffff'
              fgColor='#000000'
              level='M'
            />
          </Box>
        </Flex>
        <QRModal open={isQR} onOpenChange={(e) => setQR(e)} />
      </Card.Body>
    </Card.Root>
  )
}

export default CashbackQR
